<template>
  <div class="wrap">
    <!-- <div @click="changeProject" class="btn1">{{level}}</div> -->
    <core @mouseover="mouseover" :alldata="projectInfo" @batteryData="batteryData($event)" :cellObjShow="cellObjShow" />
    <!-- mouseover -->
    <div v-show="tip.name" :style="{ left: tip.l + 'px', top: tip.t + 'px' }" id="mouseoverpop" @click="poplabelclick">{{ tip.name }}</div>
    <!-- hotpois -->
    <poi
      v-for="(poi, index) in pois"
      :key="index + 'poi'"
      @mouseenter.native="mouseenter(index)"
      @mouseleave.native="mouseleave"
      @click.native="poplabelclick(index)"
      v-show="poi.show & (level === 0)"
      :poidata="poi"
    ></poi>
    <!-- hotcus -->
    <poi2
      @click.native="poplabelclick2(index)"
      v-for="(poi, index) in inpois"
      :key="index"
      v-show="poi.show & (level === 2 || (level === 4) & !poi.isBattery)"
      :poidata="poi"
    ></poi2>
    <!-- <bottomnav :titledata="{ title: title }" /> -->

    <component
      v-if="popcu.show"
      v-bind:is="'datapop'"
      :datainfo="{
        styledata: { l: 3, t: 0.3, w: 1.6, h: 0.18 },
        panelName: popcu.datainfo.panelName,
        componentname: 'cuwarning',
        data: popcu.datainfo.data
      }"
    ></component>

    <!-- <component v-if="popcu.show" v-bind:is="'datapop'" :datainfo="{
        styledata: { l: 5, t: 0.2, w: 2, h: 0.18 },
        panelName: '簇信息',
        componentname: 'cu',
        data: popcu.datainfo.data,
      }">
  </component> -->

    <div class="left" v-if="level != 0">
      <div class="leftrightin">
        <div class="flexitem" v-for="(item, index) in windowsinfos.left" :key="index"><component v-bind:is="'datapop'" :datainfo="item"></component></div>
      </div>
    </div>
    <div class="right" v-if="level != 0">
      <div class="leftrightin">
        <div class="flexitem" v-for="(item, index) in windowsinfos.right" :key="index"><component v-bind:is="'datapop'" :datainfo="item"></component></div>
      </div>
    </div>

    <div v-show="cellDiv" :style="{ left: location.x + 100 + 'px', top: location.y + 'px' }" id="cellpop">
      <div v-show="isBatteryCellBlock" class="batteryCellPart" ref="batteryCellPart">
        <div class="module">
          <div class="border">
            <!-- 插箱模组个数 -->
            <div class="plugBox" v-for="(item1, index1) in plugBoxModuleCount" :key="index1">
              <!-- 每个模组里电芯的个数 -->
              <div class="moduleBlock" v-for="(item2, index2) in columnCount" :key="index2">
                <div class="batteryCell">
                  <div class="batteryCellLabel"></div>
                  <img class="batteryCellImg" :src="voltImgSrc" alt="" />
                  <p class="voltageValue"></p>
                </div>
              </div>
              <!-- 负极 -->
              <div v-if="index1 == 0" class="polarityBlock negativePole">
                <img src="../../../static/images/webgl/negativePole.png" alt="" />
                <div class="mark"><i class="icon el-icon-minus"></i></div>
                <div class="title">负极</div>
              </div>
              <!-- 正极 -->
              <div v-else class="polarityBlock positivePole">
                <img src="../../../static/images/webgl/positivePole.png" alt="" />
                <div class="mark"><i class="icon el-icon-plus"></i></div>
                <div class="title">正极</div>
              </div>
            </div>
            <div class="tempModule tempModule1">
              <div class="tempModuleBlock" v-for="(item3, index3) in tempColumnNum1" :key="index3">
                <img class="temperatureImg" :src="tempImgSrc" alt="" />
                <div class="number">
                  <p class="numLabel">#{{ index3 + 1 }}</p>
                  <p class="tempValue"></p>
                </div>
              </div>
            </div>
            <div class="tempModule tempModule2">
              <div class="tempModuleBlock" v-for="(item3, index3) in tempColumnNum2" :key="index3">
                <img class="temperatureImg" :src="tempImgSrc" alt="" />
                <div class="number">
                  <p class="numLabel">#{{ index3 + tempColumnNum2 + 1 }}</p>
                  <p class="tempValue"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="!isBatteryCellBlock" class="dataModule">
        <div class="border">
          <div class="content">
            <div class="voltPart">
              <div class="value">{{ highVoltPlugBox.voltage ? Number(highVoltPlugBox.voltage).toFixed(3) + 'V' : '-' }}</div>
              <div class="label">电压</div>
            </div>
            <div class="currentPart">
              <div class="value">{{ highVoltPlugBox.current ? Number(highVoltPlugBox.current).toFixed(3) + 'A' : '-' }}</div>
              <div class="label">电流</div>
            </div>
            <div class="resistancePart">
              <div class="value">{{ highVoltPlugBox.resistancePositive ? Number(highVoltPlugBox.resistancePositive).toFixed(3) + 'kΩ' : '-' }}</div>
              <div class="label">绝缘正极电阻</div>
            </div>
            <div class="resistancePart">
              <div class="value">{{ highVoltPlugBox.resistanceNegative ? Number(highVoltPlugBox.resistanceNegative).toFixed(3) + 'kΩ' : '-' }}</div>
              <div class="label">绝缘负极电阻</div>
            </div>
            <div class="mainPositivePart">
              <div class="value">
                <img v-if="highVoltPlugBox.majorPositive == 0" :src="openImgSrc" alt="" style="width: 30px;" />
                <img v-if="highVoltPlugBox.majorPositive == 1" :src="closeImgSrc" alt="" style="width: 30px;" />
              </div>
              <div class="label">主正</div>
            </div>
            <div class="mainNegativePart">
              <div class="value">
                <img v-if="highVoltPlugBox.majorNegative == 0" :src="openImgSrc" alt="" style="width: 30px;" />
                <img v-if="highVoltPlugBox.majorNegative == 1" :src="closeImgSrc" alt="" style="width: 30px;" />
              </div>
              <div class="label">主负</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import core from './canvas.vue';
import poi from './ui/poi.vue';
import poi2 from './ui/poi2.vue';
import datapop from './ui/pop/datapop.vue';
// import bottomnav from "./ui/data/nav.vue";
import config from './LevelsShow/config.js';
import API from '@/api/webgl';
import { transProjectInfo, unTransProjectInfo } from './mock/apifilter.js';
import { LevelsShow } from './LevelsShow/LevelsShow';
window.levelsShowIns = new LevelsShow();
// levelsShowIns.loader.loads(levelsShowIns.scene,[
//   {name:'product1.glb',path:'/static/webgl/'},
//   {name:'product2.glb',path:'/static/webgl/'},
//   {name:'product3.glb',path:'/static/webgl/'},
//   {name:'product4.glb',path:'/static/webgl/'},
//   {name:'product5.glb',path:'/static/webgl/'},
//   {name:'product6.glb',path:'/static/webgl/'},
//   {name:'product1in.glb',path:'/static/webgl/'},
//   {name:'product2in.glb',path:'/static/webgl/'},
//   {name:'product3in.glb',path:'/static/webgl/'},
//   {name:'product4in.glb',path:'/static/webgl/'},
//   {name:'product5in.glb',path:'/static/webgl/'},
//   {name:'product6in.glb',path:'/static/webgl/'},
//   {name:'electricalBox.glb',path:'/static/webgl/'},
//   {name:'powerBox.glb',path:'/static/webgl/'},
//   // {name:'scene.glb',path:'/static/webgl/'},
//   {name:'battery.glb',path:'/static/webgl/'},
//   {name:'highVoltage.glb',path:'/static/webgl/'},
//   {name:'wind.glb',path:'/static/webgl/'},
//   {name:'park.glb',path:'/static/webgl/'},
//   {name:'tower.glb',path:'/static/webgl/'},
//   {name:'light.glb',path:'/static/webgl/'},
// ])
import _ from 'lodash';
export default {
  name: 'Webgl',
  components: {
    core,
    poi,
    poi2,
    datapop
    // bottomnav,
  },
  props: ['projectid', 'panelShow', 'isShowMenu'],
  data() {
    return {
      projectInfo: {},
      windowsinfos: [],
      activeproducttype: 'null',
      activeproductid: 'null',
      level: 0, //0 大场景 1大场景单类设备 2 productIn  3 电池展开
      tip: {
        l: '0px',
        t: '0px',
        name: null,
        nodeId: null
      }, //mouseover触发
      pois: [], //项目热点
      popmodel: {
        id: 0,
        l: '0px',
        t: '0px',
        show: 0
      },
      popcu: {
        id: 0,
        l: '0px',
        t: '0px',
        show: 0
      },
      inpois: [
        //product in 热点
        // { show: true, left: 30, top: 30, s: 1, name: "data2" ,isBattery:0},
      ],
      cellDiv: false,
      cellObjShow: false,
      location: {
        x: 1000,
        y: 400
      },
      plugBoxModuleCount: 1,
      columnCount: 0,
      tempColumnNum1: 1,
      tempColumnNum2: 1,
      voltImgSrc: '/static/images/webgl/cell.png',
      tempImgSrc: '/static/images/webgl/temperatureIcon.png',
      isBatteryCellBlock: true,
      highVoltPlugBox: {
        voltage:  0,
        current: 0,
        resistancePositive: '0',
        resistanceNegative: '0',
        majorPositive: '0',
        majorNegative: '0'
      },
      openImgSrc: '/static/images/webgl/open.png',
      closeImgSrc: '/static/images/webgl/close.png',
      moduleWidth: 0
    };
  },
  async created() {
    // window.$vmm = this
    await this.changeProject(this.projectid);
    levelsShowIns.eventbus.$on('pois', this.changepois);
    levelsShowIns.eventbus.$on('inpois', this.changeInpois);
    levelsShowIns.eventbus.$on('levelchange', this.levelchange);
    levelsShowIns.eventbus.$on('modelclick', this.modelclick);
    levelsShowIns.eventbus.$on('draging', this.modelhide);
  },
  beforeDestroy() {
    levelsShowIns.eventbus.$off('pois', this.changepois);
    levelsShowIns.eventbus.$off('inpois', this.changeInpois);
    levelsShowIns.eventbus.$off('levelchange', this.levelchange);
    levelsShowIns.eventbus.$off('modelclick', this.modelclick);
    levelsShowIns.eventbus.$off('draging', this.modelhide);
  },
  activated() {
    // console.log("激活activated钩子函数");
    // if(this.$route.params.id === this.projectInfo.id ){}else{
    //   this.changeProject(this.$route.params.id);
    // }
  },
  computed: {
    title() {
      let title = '徐水传动项目';
      if (this.level == 0) {
        this.$emit('glPanel', false);
        return title;
      } else {
        try {
          title = levelsShowIns.activeIn.lastmesh.$objinfo.meta.name;
        } catch (error) {}
        return title;
      }
    }
  },
  watch: {
    isShowMenu(val) {
      let nwCenter = document.getElementsByClassName('nw-center');
      if (val) {
        nwCenter[0].children[0].style.marginTop = '11%';
        nwCenter[0].children[0].style.marginLeft = '20px';
      } else {
        nwCenter[0].children[0].style.marginTop = '8%';
        nwCenter[0].children[0].style.marginLeft = '0px';
      }
    },
    projectid: function(newval, oldval) {
      if (newval === oldval) {
      } else {
        this.changeProject(newval);
      }
    },
    async activeproductid(newval, oldval) {
      this.$emit('glPanel', true);
      if (newval === oldval) return false;
      if (!newval) return false;
      if (newval == 'null') {
        this.windowsinfos = [];
        return false;
      }
      this.productloading = true;
      let projectId = this.projectid;
      let combineId = parseInt(newval.split('_')[1]);
      if (!combineId) {
        this.productloading = false;
        return false;
      }
      this.windowsinfos = [];
      let res = await API.searchFixSimulationPanelData({
        projectId,
        combineId
      });

      this.productloading = false;
      this.windowsinfos = this.layout(res.data.data);
      // console.log(this.windowsinfos);
      this.activeproducttype = levelsShowIns.activeIn.type;
    },
    panelShow(val) {
      if (!val) {
        this.level = 0;
      } else {
        this.level = 10;
      }
    }
  },
  methods: {
    setPointerEvent() {},
    layout(windowsinfos) {
      let left = [];
      let right = [];
      let book = {
        5: {
          width: 1.7,
          forheight: 1,
          height: 3,
          name: 'pcs'
        },
        6: {
          width: 1.8,
          forheight: 1,
          height: 3,
          name: 'bms'
        },
        7: {
          width: 1.6,
          forheight: 1,
          height: 1,
          name: 'kongtiao'
        },
        8: {
          width: 1.35,
          forheight: 1,
          height: 3,
          name: 'iodi'
        },
        555: {
          width: 1.6,
          forheight: 1,
          height: 2,
          name: 'wendushidu'
        },
        空调: {
          width: 1.6,
          forheight: 1,
          height: 1,
          name: 'kongtiao'
        }
      };
      let lefth = 0;
      let righth = 0;
      let kongtiao = {
        panelName: '空调',
        panelId: '空调',
        data: []
      };
      let windowsinfos1 = [];
      for (let index = 0; index < windowsinfos.length; index++) {
        let item = windowsinfos[index];
        if (item.panelId == 7) {
          kongtiao.data.push(item);
          book['空调'].height += book['空调'].forheight;
        } else {
          windowsinfos1.push(item);
        }
      }
      if (kongtiao.data.length !== 0) windowsinfos1.push(kongtiao);

      for (let index = 0; index < windowsinfos1.length; index++) {
        let item = windowsinfos1[index];
        item.componentname = book[item.panelId].name;
        item.styledata = {
          w: book[item.panelId].width
        };
        if (righth < lefth) {
          right.push(item);
          righth += book[item.panelId].height;
        } else {
          left.push(item);
          lefth += book[item.panelId].height;
        }
      }
      return {
        left,
        right
      };
    },
    mouseenter(index) {
      let l = this.pois[index].left + 20;
      let t = this.pois[index].top - 30;
      let name = this.pois[index].name;
      let nodeId = this.pois[index].nodeId;
      this.mouseover({
        l,
        t,
        name,
        nodeId
      });
    },
    mouseleave(type) {
      let l = 0;
      let t = 0;
      let name = '';
      this.mouseover({
        l,
        t,
        name
      });
    },
    mouseenter2(index) {
      let l = this.inpois[index].left + 20;
      let t = this.inpois[index].top - 30;
      let name = this.inpois[index].name;
      this.mouseover({
        l,
        t,
        name
      });
    },
    async changeProject(p) {
      // let res = await getMockProjectInfo(p);
      // let res2 = await searchSimulationEquipmentList(p);
      // console.log(res2);
      //获取告警数据
      let alarm = '';
      let res = await API.getProjectAlarmList({ projectId: p });
      if (res.data.data) {
        alarm = res.data.data;
      }
      //获取数据模型列表
      res = await API.searchSimulationEquipmentListV2({
        projectId: p,
        templateId: 0
      });
      let id = p;
      let layout = [];
      let allData = ''
      //获取项目布局模型
      if (res.data.data) {
        allData = res.data.data
        layout = transProjectInfo(allData);
      }
      //加载基础模型
      let loaders = [
        {
          name: 'battery.glb',
          path: '/static/webgl/'
        },
        {
          name: 'highVoltage.glb',
          path: '/static/webgl/'
        }
      ];
      //获取后台数据类型分组
      let meshTypes = _.groupBy(layout, function(o) {
        return o.meta.meshType;
      });
      //筛选类型
      for (const key in meshTypes) {
        if (Object.hasOwnProperty.call(meshTypes, key)) {
          if (key !== 'null' && key !== 'ground' && key !== '水泥台') {
            loaders.push({
              name: key + '.glb',
              path: '/static/webgl/'
            });
          }
        }
      }
      //场景里加载模型
      await levelsShowIns.loader.loads(levelsShowIns.scene, loaders);

      //挂载项目信息
      this.projectInfo = {
        id,
        layout,
        alarm
      };
      levelsShowIns.eventbus.$emit('levelchange', 0);
    },
    //改变级别
    levelchange(p) {
      this.modelhide();
      if (p == 0 || p == 1) {
        this.activeproducttype = 'null';
        this.activeproductid = 'null';
        this.level = 0;
      } else {
        this.activeproductid = levelsShowIns.activeOut;
        this.level = p;
      }
    },
    changepois(pois) {
      this.pois = pois;
    },
    changeInpois(pois) {
      this.inpois = pois;
    },
    mouseover(e) {
      this.tip.l = e.l;
      this.tip.t = e.t;
      this.tip.name = e.name;
      if (this.tip.name) {
        this.cellObjShow = true;
      } else {
        this.cellObjShow = false;
      }
      this.tip.nodeId = e.nodeId;
    },
    poplabelclick2(index) {
      //productIn hot 点击
      if (this.inpois[index].isBattery) {
        if (
          levelsShowIns.activeIn.type === 'product2' ||
          levelsShowIns.activeIn.type === 'product3' ||
          levelsShowIns.activeIn.type === 'product5' ||
          levelsShowIns.activeIn.type === 'product7'
        ) {
          levelsShowIns.activeIn.showModels();
        }
      } else {
        // alert(this.inpois[index].name);
        this.modelhide();
        this.cushow(this.inpois[index].name, this.inpois[index].left, this.inpois[index].top);
      }
    },
    modelclick(p) {
      //模型点击
      this.modelshow(p.mesh.id, p.poi.l, p.poi.t);
    },
    modelshow(id, l, t) {
      this.popcu.show = 0;
      this.popmodel.id = id;
      this.popmodel.l = l + 'px';
      this.popmodel.t = t + 'px';
      this.popmodel.show = 1;
    },
    //隐含非3d模型
    modelhide() {
      this.popmodel.id = 0;
      this.popmodel.l = '0px';
      this.popmodel.t = '0px';
      this.popmodel.show = 0;
      this.popcu.id = 0;
      this.popcu.l = '0px';
      this.popcu.t = '0px';
      this.popcu.show = 0;
      this.cellDiv = false;
    },
    //显示簇数据
    async cushow(id, l, t) {
      this.popcu.id = id.split('#')[0];
      this.popcu.l = l + 'px';
      this.popcu.t = t + 'px';
      let projectId = this.projectid;
      if (this.activeproductid) {
        //簇编号规则
        let combineId = parseInt(this.activeproductid.split('_')[1]) + '#clu' + parseInt(this.popcu.id);
        let res = await API.searchFixSimulationPanelData({
          projectId,
          combineId
        });
        this.popcu.datainfo = res.data.data[0];
        this.popcu.show = 1;
      }
    },
    async poplabelclick() {
      // let name = this.tip.name;
      // let mesh = levelsShowIns.scene.getMeshByID(name);
      // if (mesh.$modeinfo) {
      //   //电池模块 或者 高压模块
      //   this.modelshow(mesh.$modeinfo.id,this.tip.l,this.tip.t)
      //   return false;
      // }
      // levelsShowIns.eventbus.$emit('meshhide', { id:this.tip.nodeId, visibility: 0 });
      // mesh.visibility = 1.0;
      // mesh.isPickable = true;
      // if (name.indexOf('table') > -1) {
      //   levelsShowIns.camera.cameraGoMesh(mesh);
      //   levelsShowIns.eventbus.$emit('levelchange', 1);
      // } else {
      //   await levelsShowIns.camera.cameraGoMesh(mesh);
      //   levelsShowIns.meshIn(mesh);
      //   levelsShowIns.eventbus.$emit('levelchange', 2);
      // }
    },
    //电池数据
    batteryData(e) {
      this.cellDiv = true;
      this.location.x = this.tip.l;
      this.location.y = this.tip.t;
      if (!e.gao) {
        this.isBatteryCellBlock = true;
        this.plugBoxModuleCount = e.plugBoxModuleCount;
        this.columnCount = e.moduleBunc;
        let tempColumnCount = e.temp.length;
        if (tempColumnCount % 2 == 0) {
          this.tempColumnNum1 = this.tempColumnNum2 = tempColumnCount / 2;
        } else {
          this.tempColumnNum1 = Math.ceil(tempColumnCount / 2);
          this.tempColumnNum2 = Math.floor(tempColumnCount / 2);
        }
        this.$nextTick(() => {
          var batteryCellImgs = document.getElementsByClassName('batteryCellImg');
          if (batteryCellImgs.length > 0) {
            for (let i = 0; i < batteryCellImgs.length; i++) {
              if (batteryCellImgs[i].src) {
                batteryCellImgs[i].src = this.voltImgSrc;
              }
            }
          }
          let div = this.$refs.batteryCellPart.children[0].children[0].children[0].children[this.columnCount - 1].children[0].children[1].children;
          for (let i = 0; i < div.length; i++) {
            div[i].style.color = '#fff';
            div[i].style.fontWeight = '600';
          }
          //计算插箱宽度
          let plugBox = document.getElementsByClassName('plugBox');
          let batteryCellPart = document.getElementsByClassName('batteryCellPart');
          let cellWidth = '';
          let moduleWidth = '';
          for (let i in plugBox) {
            if (plugBox[i].className == 'plugBox' && batteryCellImgs[0]) {
              if (this.plugBoxModuleCount == 1) {
                plugBox[i].style.width = (batteryCellImgs[0].width + 4.4) * (this.columnCount + 1) + 'px';
                cellWidth = (batteryCellImgs[0].width + 4.4) * this.columnCount;
                moduleWidth = ((batteryCellImgs[0].width + 4.4) * (this.columnCount + 1)).toFixed(2);
              } else if (this.plugBoxModuleCount == 2) {
                plugBox[i].style.width = (batteryCellImgs[0].width + 5.2) * (this.columnCount + 1) + 'px';
                cellWidth = (batteryCellImgs[0].width + 5.2) * this.columnCount;
                moduleWidth = ((batteryCellImgs[0].width + 5.2) * (this.columnCount + 1) * 2).toFixed(2);
              } else if (this.plugBoxModuleCount == 3) {
                plugBox[i].style.width = (batteryCellImgs[0].width + 5) * (this.columnCount + 1) + 'px';
                cellWidth = (batteryCellImgs[0].width + 5) * this.columnCount;
                moduleWidth = ((batteryCellImgs[0].width + 5) * (this.columnCount + 1) * 3).toFixed(2);
              }
            }
          }
          batteryCellPart[0].style.width = plugBox[0].style.width;
          this.moduleWidth = moduleWidth;
          //计算一个温度点的宽度
          let tempModule = document.getElementsByClassName('tempModule');
          for (let i in tempModule) {
            if (tempModule[i].style) {
              tempModule[i].style.width = cellWidth + 'px';
            }
          }
          var tempModuleBlock = document.getElementsByClassName('tempModuleBlock');
          if (tempModuleBlock.length > 0) {
            for (let i = 0; i < tempModuleBlock.length; i++) {
              tempModuleBlock[i].style.width = parseInt(tempModule[0].style.width) / this.tempColumnNum1 + 'px';
              tempModuleBlock[i].style.background = 'transparent';
            }
          }
          var temperatureImgs = document.getElementsByClassName('temperatureImg');
          for (let i = 0; i < temperatureImgs.length; i++) {
            if (temperatureImgs[i].src) {
              temperatureImgs[i].src = this.tempImgSrc;
              temperatureImgs[i].style.width = parseInt(tempModule[0].style.width) / this.tempColumnNum1 + 'px';
            }
          }
          var numberDiv = document.getElementsByClassName('number');
          for (let i = 0; i < numberDiv.length; i++) {
            numberDiv[i].style.background = 'transparent';
            numberDiv[i].style.width = parseInt(tempModule[0].style.width) / this.tempColumnNum1 + 'px';
          }
          let vPart1 = [];
          let vPart2 = [];
          if (e.cell.length > 0) {
            for (let i = 0; i < e.cell.length / 2; i++) {
              vPart1.push(e.cell[i]);
            }
            for (let i = e.cell.length / 2; i < e.cell.length; i++) {
              vPart2.push(e.cell[i]);
            }
          }
          vPart1.sort((a, b) => {
            return b.id - a.id;
          });
          e.cell = vPart1.concat(vPart2);
          let tPart1 = [];
          let tPart2 = [];
          if (e.temp.length > 0) {
            for (let i = 0; i < Math.ceil(e.temp.length / 2); i++) {
              tPart1.push(e.temp[i]);
            }
            for (let i = Math.ceil(e.temp.length / 2); i < e.temp.length; i++) {
              tPart2.push(e.temp[i]);
            }
          }
          tPart1.sort((a, b) => {
            return b.id - a.id;
          });
          tPart2.sort((a, b) => {
            return b.id - a.id;
          });
          e.temp = tPart1.concat(tPart2);
          // console.log(e.temp);
          // console.log(e.cell);

          var batteryCellLabel = document.getElementsByClassName('batteryCellLabel');
          for (let i = 0; i < batteryCellLabel.length; i++) {
            if (e.cell.length > 0) {
              batteryCellLabel[i].innerHTML =  e.cell[i].num;
              if(e.cell[i].haveAlarm==true){
                batteryCellLabel[i].style.color = 'red';
              }else{
                batteryCellLabel[i].style.color = '#ffffff';
              }
            }
          }
          var voltValue = document.getElementsByClassName('voltageValue');
          for (let i = 0; i < voltValue.length; i++) {
            if (e.cell.length > 0) {
              voltValue[i].innerHTML = Number(e.cell[i].value).toFixed(3);
              if(e.cell[i].haveAlarm==true){
                voltValue[i].style.color = 'red';
              }else{
                voltValue[i].style.color = '#ffffff';
              }
            }
          }
          var numLabel = document.getElementsByClassName('numLabel');
          for (let i = 0; i < numLabel.length; i++) {
            numLabel[i].style.color = '#F6F7C2';
            if (e.temp.length > 0 && e.temp[i]) {
              numLabel[i].innerHTML = e.temp[i].num;
            }
            if(e.temp[i].haveAlarm==true){
              numLabel[i].style.color = 'red';
            }
          }
          var tempValue = document.getElementsByClassName('tempValue');
          for (let i = 0; i < tempValue.length; i++) {
            tempValue[i].innerHTML = parseInt(e.temp[i].value) + '℃';
            tempValue[i].style.background = 'transparent';
            tempValue[i].style.color = '#F6F7C2';
            if(e.temp[i].haveAlarm==true){
              tempValue[i].style.color = 'red';
            }
          }
        });
      }else{
        this.isBatteryCellBlock = false;
        this.highVoltPlugBox = {
          current: e.current,
          voltage:e.voltage,
          majorNegative: e.majorNegative,
          majorPositive: e.majorPositive,
          resistanceNegative: e.resistanceNegative,
          resistancePositive:e.resistancePositive
        };
        let dataModule = document.getElementsByClassName('dataModule');
        if (this.moduleWidth != 0) {
          dataModule[0].style.width = this.moduleWidth + 5 + 'px';
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#mouseoverpop {
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  font-size: 0.05rem;
  color: #4de7ff;
  z-index: 999;
  transition: 300ms;
  padding: 0.03rem 0.1rem;
  border: 0.02rem solid #4de7ff;
  border-radius: 0.1rem;
  transition: 300ms;
  cursor: pointer;
}

#cellpop {
  position: absolute;
  background: rgb(255, 255, 255);
  border: 3px solid #8bb1ee;
  border-radius: 4px;
  transition: 300ms;
  z-index: 999;

  .batteryCellPart {
    height: calc(100% - 2px);
    float: left;

    .border>:nth-child(2),
    // .border>:nth-child(3) {
    //   border-left: 3px solid rgba(128, 163, 240, 0.38);
    // }

    .plugBox {
      float: left;
      padding: 3px 0px;
      display: flex;
      justify-content: space-evenly;

      .moduleBlock,
      .moduleRight {
        height: 100%;
        float: left;
      }

      .batteryCell {
        width: 40px;
        height: 107px;
        position: relative;
        text-align: center;

        .batteryCellLabel {
          width: 35px;
          height: 18px;
          background: #e86e2c;
          border-radius: 2px;
          color: #fff;
          font-size: 12px;
          font-family: DINBold;
          font-weight: bold;
          line-height: 18px;
          position: absolute;
          margin-top: 5px;
          margin-left: 50%;
          text-align: center;
          transform: translateX(-50%);
        }

        .voltageValue {
          color: #fff;
          font-size: 12px;
          font-family: DINBold;
          font-weight: bold;
          margin-top: -75px;
        }

        .batteryCellImg {
          width: 100%;
          height: 100%;
        }

        .voltHeatMap {
          width: 100%;
          height: 100%;
        }
      }

      .polarityBlock {
        width: 40px;
        height: 107px;
        position: relative;

        .mark {
          width: 24px;
          height: 24px;
          background-color: #fff;
          border-radius: 50%;
          position: absolute;
          top: 16px;
          left: 50%;
          transform: translateX(-50%);
          text-align: center;
        }

        .icon {
          margin-top: 50%;
          transform: translateY(-50%);
        }

        .el-icon-minus:before {
          color: #fac37b;
          font-size: 16px;
          font-weight: 600;
        }

        .el-icon-plus:before {
          color: #1fdeb3;
          font-size: 16px;
          font-weight: 600;
        }

        .title {
          background: transparent;
          color: #fff;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 500;
          position: absolute;
          margin-top: -50%;
          width: 16px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    .tempModule {
      border-left: none !important;
      display: flex;
      justify-content: end;
      margin-top: 50px;
      position: absolute;
      text-align: center;
    }

    .tempModule2 {
      margin-top: 163px;
    }

    .tempModuleBlock {
      // flex: 1;
      height: 50px;
      float: left;
      position: relative;

      .temperatureImg {
        width: 100%;
        height: 100%;
      }

      .number {
        margin-top: -37px;
      }

      .numLabel {
        color: #ffca65;
        font-size: 12px;
        font-family: PingFang;
        font-weight: 600;
      }
    }

    .tempValue {
      color: #ffca65;
      font-size: 12px;
      font-family: PingFang;
      font-weight: 600;
    }
  }

  .dataModule {
    min-width: 560px;

    .border {
      height: 120px;
    }

    .content {
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .voltPart,
    .currentPart,
    .resistancePart {
      min-width: 88px;
      height: 88px;
      background: linear-gradient(180deg, #9dbdfa 0%, #3f73e8 100%);
      border-radius: 3px;
      border: 1px solid #039bf0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 5px;
    }

    .resistancePart {
      min-width: 120px;
    }

    .mainPositivePart,
    .mainNegativePart {
      width: 50px;
      height: 88px;
      background: linear-gradient(180deg, #9dbdfa 0%, #3f73e8 100%);
      border-radius: 3px;
      border: 1px solid #039bf0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 10px;
    }

    .value {
      font-size: 18px;
      font-family: Helvetica;
      font-weight: bold;
      color: #ffffff;
    }

    .label {
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #ffffff;
    }
  }
}

.wrap {
  position: absolute;
  width: 10rem;
  height: 100%;
  overflow: hidden;
  left: 0vw;
  top: 0vh;
  z-index: 9;
  background: linear-gradient(rgb(90, 29, 29), #000);
}

.btn1 {
  position: fixed;
  width: 100px;
  height: 16px;
  left: 1rem;
  top: 0.1rem;
  z-index: 9999;
  color: #fff;
}

.title {
  position: fixed;
  width: 200px;
  height: 40px;
  left: 40px;
  top: 80px;
  z-index: 9999;
  color: #fff;
  background: #000;
}

.left {
  position: absolute;
  left: 0.1rem;
  height: 100vh;
  overflow-y: auto;
}

.pointerEventsNone {
  pointer-events: none;
}

.right {
  position: absolute;
  right: 0.1rem;
  height: 100vh;
  overflow-y: auto;
}

.leftrightin {
  min-height: 99vh;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  pointer-events: none;
}

.flexitem {
  margin-top: 0.35rem;
  pointer-events: initial;
}

.flexitem:last-child {
  margin-bottom: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/webgl/index.vue